import {detailServicesPath, ordersServicesPath} from "../../../Constants";
import axios from "axios";

const restUrl = detailServicesPath + '/organizations/machines'

export default class MachinesService {
    static async getAll() {
        return axios.get(restUrl);
    }

    static async update(data, id) {
        return await axios.put(restUrl + '/' + id, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async save(machineManufacturer, name) {
        return await axios.post(`${restUrl}?machineManufacturer=${machineManufacturer}&name=${name}`, JSON.stringify({}), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(id) {
        await axios.delete(restUrl + '/' + id);
    }
}